module.exports = __webpack_public_path__ + "static/media/mt-ut-img-4.a8682785.webp";